import useDataSelector from "../../../hooks/useDataSelector";
import { useAppSelector } from "../../../store/hooks";
import { ganttChartVerticalValues } from "../../../utils/ganttChartValues";
import UnplannedTasks from "./UnplannedTasks";
import VerticalGanttChartTaskWrapper from "./VerticalGanttChartTaskWrapper";
import { Fragment } from "react";

const VerticalGanttChartContent = ({
  unplannedTaskWidth,
  unplannedColumnWidth,
}: {
  unplannedTaskWidth: number;
  unplannedColumnWidth: number;
}) => {
  const { verticalColumnWidth } = useAppSelector(
    (state) => state.ganttChartSlice,
  );
  const dataToUse = useDataSelector();

  const { timelineRange } = useAppSelector((state) => state.timelineSlice);

  return (
    <>
      {/* Unplanned tasks */}
      {dataToUse && timelineRange && (
        <UnplannedTasks
          taskWidthPx={unplannedTaskWidth}
          unplannedTasks={dataToUse.generalGanttChartInfo.unplannedTasks}
        />
      )}
      {/* Planned Tasks */}
      {dataToUse &&
        timelineRange &&
        dataToUse.employees.map((employee, index) => (
          <Fragment key={index}>
            <VerticalGanttChartTaskWrapper
              key={`tasks-${index}`}
              employee={employee}
              useColorGroupingsAsTeamSplitter={
                dataToUse.useColorGroupingsAsTeamSplitter
              }
              xPosition={
                ganttChartVerticalValues.timelineColumn +
                unplannedColumnWidth +
                index * verticalColumnWidth
              }
            />
          </Fragment>
        ))}
    </>
  );
};

export default VerticalGanttChartContent;
